import moment from "moment";

// certain formats don't work if you pass in a string so always reassign it to a date first
export const formatDate = (date, format = "YYYY-MM-DD") =>
  moment(new Date(date)).format(format);
